var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3370_39116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.254 7.74604C15.1746 6.66667 13.6508 5.96826 12 5.96826C10.3492 5.96826 8.82541 6.63493 7.74604 7.74604C6.66667 8.82541 5.96826 10.3492 5.96826 12C5.96826 13.6508 6.66667 15.1746 7.74604 16.254C8.82541 17.3333 10.3492 18.0318 12 18.0318C13.6508 18.0318 15.1746 17.3651 16.254 16.254C17.3333 15.1746 18.0318 13.6508 18.0318 12C18.0318 10.3492 17.3651 8.82541 16.254 7.74604ZM15.1111 15.1111C14.3175 15.9048 13.2064 16.381 12 16.381C10.7937 16.381 9.68255 15.9048 8.8889 15.1111C8.09525 14.3175 7.61906 13.2064 7.61906 12C7.61906 10.7937 8.09525 9.68255 8.8889 8.8889C9.68255 8.09525 10.7937 7.61906 12 7.61906C13.2064 7.61906 14.3175 8.09525 15.1111 8.8889C15.9048 9.68255 16.381 10.7937 16.381 12C16.381 13.2064 15.9048 14.3175 15.1111 15.1111Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1746 11.1746H20.7302C20.2857 11.1746 19.9048 11.5555 19.9048 12C19.9048 12.4444 20.2857 12.8254 20.7302 12.8254H23.1746C23.6191 12.8254 24 12.4444 24 12C24 11.5555 23.6191 11.1746 23.1746 11.1746Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.9048C11.5555 19.9048 11.1746 20.2857 11.1746 20.7302V23.1746C11.1746 23.6191 11.5555 24 12 24C12.4444 24 12.8254 23.6191 12.8254 23.1746V20.7302C12.8254 20.2857 12.4444 19.9048 12 19.9048Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4761 19.3334L18.7301 17.5873C18.4444 17.2699 17.9047 17.2699 17.5872 17.5873C17.2698 17.9048 17.2698 18.4127 17.5872 18.7302L19.3332 20.4762C19.6507 20.7937 20.1586 20.7937 20.4761 20.4762C20.7936 20.1588 20.7936 19.6508 20.4761 19.3334Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C11.5555 0 11.1746 0.380952 11.1746 0.825397V3.26984C11.1746 3.71429 11.5555 4.09524 12 4.09524C12.4444 4.09524 12.8254 3.71429 12.8254 3.26984V0.825397C12.8254 0.380952 12.4444 0 12 0Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5078 3.52386C20.1904 3.2064 19.6824 3.2064 19.365 3.52386L17.619 5.26989C17.3015 5.58735 17.3015 6.09529 17.619 6.41275C17.9047 6.73021 18.4444 6.73021 18.7618 6.41275L20.5078 4.66672C20.8253 4.34926 20.8253 3.84132 20.5078 3.52386Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26984 11.1746H0.825397C0.380952 11.1746 0 11.5555 0 12C0 12.4444 0.349206 12.8254 0.825397 12.8254H3.26984C3.71429 12.8254 4.09524 12.4444 4.09524 12C4.09524 11.5555 3.71429 11.1746 3.26984 11.1746Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38089 17.5873C6.09518 17.2699 5.55549 17.2699 5.23803 17.5873L3.492 19.3334C3.17454 19.6508 3.17454 20.1588 3.492 20.4762C3.80946 20.7937 4.3174 20.7937 4.63486 20.4762L6.38089 18.7302C6.69835 18.4127 6.69835 17.9048 6.38089 17.5873Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38089 5.26989L4.63486 3.52386C4.3174 3.2064 3.80946 3.2064 3.492 3.52386C3.17454 3.84132 3.17454 4.34926 3.492 4.66672L5.23803 6.41275C5.55549 6.73021 6.06343 6.73021 6.38089 6.41275C6.69835 6.09529 6.69835 5.58735 6.38089 5.26989Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3370_39116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightTheme);
export default __webpack_public_path__ + "static/media/icon-light-theme.0494c9116216a5db619af7b5ee61d0f2.svg";
export { ForwardRef as ReactComponent };